export enum TariffType {
  TRADITIONAL = 'TRADITIONAL',
  DIGITAL = 'DIGITAL',
}
